import { useSelector } from 'react-redux'
import { faGraduationCap, faSchool, faUserGraduate } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { INSTITUTION_MACCS_CONTEXT, SCHOOL_MACCS_CONTEXT, InternshipStates } from '../../../utils/constants'
import InternshipValidationButton from '../../../Components/shared/ShiftsManager/InternshipValidationButton'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

import '../../../assets/maccs-shifts-manager.scss'
import AssistantMenu from './AssistantMenu'

const InternshipCard = ({ context, internship, onSelectInternship, onSelectAssistant, onSelectValidation }) => {
  const t = useSelector(selectTranslate)

  const getValidateButtonTooltip = internship => {
    if (internship.state === InternshipStates.SCHEDULE_TO_VALIDATE) {
      return t('internship_card.internship_to_validate_tooltip')
    }

    if (internship.state === InternshipStates.SCHEDULE_VALIDATED) {
      return t('Internship validated')
    }

    return t('Validate internship')
  }

  return (
    <div className='internship-card-container'>
      <div className='internship-card-title'>
        <AssistantMenu
          internship={internship}
          onSelectedAssistant={onSelectAssistant}
          onSelectedInternship={onSelectInternship}
          inShiftManager
        />
        <div className='internship-information'>
          <div>
            <div className='regular-image'> <FontAwesomeIcon icon={faUserGraduate} /> </div>
            <span><b> {internship.assistant && `${internship.assistant.firstname} ${internship.assistant.lastname}`} </b></span>
          </div>
          <div>
            <div className='regular-image'> <FontAwesomeIcon icon={faSchool} /> </div>
            {context === SCHOOL_MACCS_CONTEXT && internship.institution && (
              <span> {internship.institution.name} </span>
            )}
            {context === INSTITUTION_MACCS_CONTEXT && internship.school && (
              <span> {internship.school.name} </span>
            )}
          </div>
          <div>
            <div className='regular-image'> <FontAwesomeIcon icon={faGraduationCap} /> </div>
            <div className='last-text'>
              {internship.speciality && internship.speciality.name}
            </div>
          </div>
        </div>
      </div>
      <div className='internship-card-buttons'>
        <InternshipValidationButton
          validateButtonTooltip={getValidateButtonTooltip(internship)}
          internship={internship}
          onDisplayValidationDrawer={onSelectValidation}
        />
      </div>
    </div>
  )
}

export default InternshipCard
